import type { FC } from 'react';
import { useEffect, useRef, useState } from 'react';
import cx from 'classnames';
import { MDText } from 'i18n-react';

import type { GalleryImage } from 'Pages/vehicles/helpers/vehicle.schema';

import { DamageImage } from '../DamageImage';
import { ReactComponent as ExpandIcon } from '../icons/expand.svg';
import { ReactComponent as ShrinkIcon } from '../icons/shrink.svg';

import LocalTexts from './DamageLocation.text';

import styles from './DamageLocation.module.scss';

const LocalT = new MDText(LocalTexts);

interface GalleryDamageLocationProps {
	className?: string;
	data: NonNullable<GalleryImage['damageMeta']>;
	onView?: () => void;
}

export const DamageLocation: FC<GalleryDamageLocationProps> = ({ className, data, onView }) => {
	const ref = useRef<HTMLDivElement>(null);
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		// eslint-disable-next-line no-unused-expressions
		isVisible && onView?.();
	}, [isVisible]);

	return (
		<div ref={ref} className={cx(styles.wrapper, className)}>
			<div className={styles.content}>
				<button
					aria-label="View damage location"
					className={styles.damageTrigger}
					data-testid="gallery-damage-location-trigger"
					onMouseEnter={() => setIsVisible(true)}
					onMouseLeave={() => setIsVisible(false)}
					onTouchEnd={() => setIsVisible((visible) => !visible)}
				>
					<span>{LocalT.translate('trigger')}</span>
					{isVisible ? <ShrinkIcon /> : <ExpandIcon />}
				</button>
				{isVisible && (
					<div className={styles.damageOverlay} data-testid="gallery-damage-location-overlay">
						<DamageImage data={data} />
					</div>
				)}
			</div>
		</div>
	);
};
